import { Entity } from '@adornis/baseql/decorators';
import { CustomContent } from '@adornis/buildify/db/CustomContent';

@Entity()
export class MarketingCustomContent extends CustomContent {
  static override _class = 'MarketingCustomContent';
  static override _collectionName = 'marketing-custom-contents';
}
